import Alert from '@storeblocks/alert';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

export const EsgInsufficientDataAlert: FC = () => {
  const texts = useTexts();

  return <Alert description={texts.pages.esg.insufficientData} />;
};
